import React, { useRef, useEffect, useState } from "react";
import "../LocalCommunityAds.css";
import "rc-slider/assets/index.css";

import SearchLca from "../../WeddingVendors/SearchLca";
import { useDispatch, useSelector } from "react-redux";

import {
  fetchItems,
  fetchSubCategories,
  fetchCategories,
  fetchSubCatByCatId,
} from "../../Data";
import { RiArrowLeftDoubleFill } from "react-icons/ri";
import {
  resetLca,
  setActiveTab,
  setSelectedSubCategory,
  setGottonData,
  setMyOffers,
} from "../../../../redux/slices/LcaSlice";
import {
  clearLcaAndBwv,
  fetchBizz,
} from "../../../../redux/slices/LcaAndBwvSlice";
import { useLocation, useNavigate } from "react-router-dom";
import RecentAds from "./RecentAds";
import LcaSideBar from "./LcaSideBar";
import axiosClient from "../../../../axios-client";
import { myOffers } from "../../Data2";
import Footer from "../../../Footer/Footer";
import Helmet from "../../../Helmet/Helmet";
import CommentNotification from "../../../Layout/notificationComment";
import { resetImageData } from "../../../../redux/slices/ImageSlice";
import SearchBwv from "../../WeddingVendors/SearchBwv";
const LocalCommunityAds = ({ setToggled }) => {
  const dataInitialized = useRef(false);
  const fetchDataCalled = useRef(false);
  const gottonFetched = useRef(false);
  const userinfo = useSelector((state) => state.user.userInfo);
  const islogin = useSelector((state) => state.user.isLogin);
  const user = islogin ? JSON.parse(userinfo) : null;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [productSubCat, setProductSubCat] = useState([]);
  const [items, setItems] = useState([]);
  const [scrollPopupVisible, setScrollPopupVisible] = useState(false);
  const location = useLocation();
  const code = new URLSearchParams(location.search).get("code");
  const { selectedSubCategory, selectedItem, currentPage } = useSelector(
    (state) => state.lcAds
  );

  useEffect(() => {
    if (code) {
      localStorage.setItem("code", code);
      navigate("/dashboardpage/settings");
    }
  }, [code]);

  useEffect(() => {
    const bizzParams = {
      type: "service",
      pageId: currentPage,
      subCategoryId:
        selectedSubCategory?.id === 63
          ? undefined
          : selectedSubCategory?.id || undefined,
    };
    dispatch(fetchBizz(bizzParams));
  }, [selectedSubCategory, selectedItem, currentPage]);

  const fetchData = async () => {
    if (dataInitialized.current) return;
    try {
      console.log("Fetching categories, subcategories, and items...");
      const [subCategoriesData, itemsData] = await Promise.all([
        fetchSubCatByCatId(1),
        fetchItems(),
      ]);
      setProductSubCat(subCategoriesData);
      setItems(itemsData);
      dataInitialized.current = true;
      console.log("Data initialization complete");
    } catch (err) {
      console.error("Error fetching data:", err);
    }
  };

  useEffect(() => {
    if (!fetchDataCalled.current) {
      fetchData();
      fetchDataCalled.current = true;
    }
    if (user && islogin && !gottonFetched.current) {
      fetchGotton();
      gottonFetched.current = true;
    }
    dispatch(setActiveTab("Customers"));
    dispatch(setSelectedSubCategory(null));
    return () => {
      dispatch(clearLcaAndBwv());
    };
  }, []);

  const fetchGotton = async () => {
    try {
      const response = await axiosClient.put(
        `message/TotalMsgMonthGetCustomer/${Number.parseInt(user.UserID)}`
      );
      const data = response.data.Data;
      const currentMonth = new Date().getMonth() + 1;
      const currentYear = new Date().getFullYear();
      const currentMonthStr = currentMonth.toString().padStart(2, "0");
      const filteredData = data.find((item) => {
        const itemMonth = item.MONTH.split("-")[1];
        const itemYear = item.MONTH.split("-")[0];
        return (
          itemMonth === currentMonthStr && itemYear === currentYear.toString()
        );
      });
      dispatch(setGottonData(filteredData));
    } catch (error) {
      console.error("Error fetching Gotton data:", error);
    }
  };
  React.useEffect(() => {
    if (islogin) {
      fetchMyOffers();
    }
  }, []);

  const handleClear = () => {
    dispatch(resetLca());
    navigate("/Localcommunityads");
  };

  const fetchMyOffers = async () => {
    const type = {
      Type: "provider",
    };
    const id = user?.UserID;
    const response = await myOffers(id, type);
    dispatch(setMyOffers(response));
  };
  return (
    <Helmet title="local ads">
      <div className="local-community-ads-container">
        <div className="px-2">
          <div
            className="text-center wc_show_cat_popup d-lg-none d-xl-block d-none"
            style={{ position: "absolute", top: "10px", left: "170px" }}
          >
            <div
              style={{
                padding: "10px",
                backgroundColor: "var(--button-bg)",
                borderRadius: "8px",
                boxShadow: "0 4px 8px var(--theme-shadow)",
                zIndex: 999,
                width: 120,
                display: "flex",
                flexDirection: "row",
                animation: "flashingColor 2s infinite",
              }}
            >
              <div
                style={{
                  fontSize: "12px",
                  fontWeight: "bold",
                  textWrap: "nowrap",
                }}
              >
                Select to view
              </div>
              <div
                style={{
                  marginTop: "-5px",
                  textAlign: "center",
                }}
              >
                <RiArrowLeftDoubleFill size={20} />
              </div>
            </div>
          </div>

          <div>
            <SearchLca />
            {/* <div className="my-1">
              <CommentNotification
                commenterName="John Doe"
                commenterAvatar="https://i.pravatar.cc/150?img=12"
                commentText="Amazing photo!"
                postThumbnail="https://images.unsplash.com/photo-1503023345310-bd7c1de61c7d?w=80&h=80&fit=crop"
                postId="12345"
              />
            </div> */}
            <RecentAds
              handleClear={handleClear}
              //   () => {
              //   dispatch(resetLca());
              // }}
              productSubCat={productSubCat}
              scrollPopupVisible={scrollPopupVisible}
              setScrollPopupVisible={setScrollPopupVisible}
              setToggled={setToggled}
            />
          </div>
        </div>
        <Footer />
      </div>
    </Helmet>
  );
};

export default LocalCommunityAds;
